import actionTypes from "constants/bgTasks";
import { Action, ActionFunctionAny, createActions } from "redux-actions";

const { ADD, UPDATE, REMOVE, REMOVE_ALL } = actionTypes;

const actions = createActions(ADD, REMOVE, REMOVE_ALL, UPDATE);

const add = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.add(params));

const update = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.update(params));

const remove = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.remove(params));

const removeAll = () => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.removeAll());

export default { ...actions, add, update, remove, removeAll };
